<div class="account-page">

  <!-- Header -->
  <div class="header">

    <p class="mini-title">
      {{ t('userDashboard') }}
    </p>

    <h1>
      {{ t('myAccount') }}
    </h1>

    <span>
      {{ t('manageYourProfile') }}
    </span>

  </div>

  <!-- Menu Grid -->
  <div class="account-grid">

    <!-- My Orders -->
<a
  routerLink="/orders"
  class="card"
>

  <div class="icon">📦</div>

  <div class="content">
    <h3>{{ t('myOrdersTitle') }}</h3>
    <p>{{ t('trackYourOrdersShort') }}</p>
  </div>

  <span class="arrow">›</span>

</a>

<a
  routerLink="/profile"
  class="card"
>

  <div class="icon">👤</div>

  <div class="content">
    <h3>{{ fullName || t('myProfile') }}</h3>

    <p>{{ email }}</p>

    <p *ngIf="phone">{{ phone }}</p>

    <p *ngIf="address">{{ address }}</p>
  </div>

  <span class="arrow">›</span>

</a>

    <!-- Logout -->
    <div
      class="card logout"
      (click)="logout()"
    >

      <div class="icon">🚪</div>

      <div class="content">
        <h3>{{ t('logout') }}</h3>
        <p>{{ t('signOutFromAccount') }}</p>
      </div>

      <span class="arrow">›</span>

    </div>

  </div>

</div>